// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PFWL","placeholdersHeader":"styles_placeholdersHeader__3NCJk","editorStyle":"styles_editorStyle__148o7","placeholdersBox":"styles_placeholdersBox__3Fyyi"};